import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface Register {
  name: string | null;
  email: string | null;
  password: string | null;
  domain_name: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  hostURL = environment.apiUrl;
  constructor(private http: HttpClient) { }

  saveCompany(data: any): Observable<any>{
    return this.http.post(`${this.hostURL}/tenants/create_tenant`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
  
  });
}

  viewTenant(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/tenants/view_tenant`);
  }
  viewTenantByUser(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/tenants/view_tenant_by_user`);
  }

  viewTenantUsers(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/tenants/tenant_users`);
  }
  createUser(data: any): Observable<any> {
    // const headers = new HttpHeaders().set('tenant_id', ''+tenant_id);
    const url = `${this.hostURL}/user/register`;
    return this.http.post(url, data);
  }

  getRoles(tenant_id:string): Observable<any> {
    const headers = new HttpHeaders().set('tenant_id', tenant_id);
    
    return this.http.get<any>(`${this.hostURL}/role/`, { headers });
  }

  createRole(data: any,tenant_id:string): Observable<any> {
    const headers = new HttpHeaders().set('tenant_id', ''+tenant_id);
    const url = `${this.hostURL}/role`;
    return this.http.post(url, data,{headers});
  }
  
  getBranches(tenant_id:string): Observable<any> {
    const headers = new HttpHeaders().set('x-tenant-id', tenant_id);
    
    return this.http.get<any>(`${this.hostURL}/branch`, { headers });
  }

  savePermission(data: any,tenant_id:string): Observable<any> {
    // const headers = new HttpHeaders().set('tenant_id', ''+tenant_id);
    const url = `${this.hostURL}/acl/assign_permission`;
    return this.http.post(url, data);
  }

  savePermissionRole(data: any,tenant_id:string): Observable<any> {
    const headers = new HttpHeaders().set('tenant_id', ''+tenant_id);
    const url = `${this.hostURL}/acl/assign_permission_role`;
    return this.http.post(url, data,{headers});
  }
  
  //legal entity
  getLegalentity(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/legalentity`);
  }

  updateLegalEntity(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/legalentity/${id}`, data);
  }
  saveLegalEntity(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/legalentity`, data);
  }
  deleteLegalentity(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/legalentity/${id}`);
  }

  //company
  getCompanyById(id: any): Observable<any> {
    return this.http.get(`${this.hostURL}/tenants/edit_tenant/${id}`);
  }
  updateCompany(id: any, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/tenants/update_tenant/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },

    });
  }

  //fetch country
  countrylist(): Observable<any> {
    return this.http.get(`${this.hostURL}/country`);
  }

  //fetch state by countryid 
  statelist(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/fetchstate/${id}`);
  }

  //fetch city by state id
  citylist(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/fetchcity/${id}`);
  }
  //fetch global unit 
  getGlobalUnit(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/globalunit`);
  }
  //fetch global unit by id
  showGlobalUnitById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/globalunit/${id}`);
  }
  //create global unit
  createGlobalUnit(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/globalunit`, data);
  }
  //update global unit
  updateGlobalUnit(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/globalunit/${id}`, data);
  }
  //fetch global item
  getGlobalItem(params:any={}): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/globalitem`, { params });
  }
  //fetch global item by id
  showGlobalItemById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/globalitem/${id}`);
  }
  //create global item by id
  createGlobalItem(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/globalitem`, data);
  }
  //update global item 
  updateGlobalItem(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/globalitem/${id}`, data);
  }
  //update enforce match of ob
  updateSelection(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/tenants/enforcematch`, data);
  }
  createHsnSac(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/hsnsac`, data);
  }
  getHsnSac(): Observable<any> {
    return this.http.get(`${this.hostURL}/hsnsac`);
  }
  updateHsnSac(id: number,data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/hsnsac/${id}`, data);
  }
  deleteHsnSac(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/hsnsac/${id}`);
  }
  getHsnSacType(type: any): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/hsnsactype`, { type });
  }
  updateGlobalGst(id: number,data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/globalgst/${id}`, data);
  }
  createGlobalGst(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/globalgst`, data);
  }
  getGlobalGst(): Observable<any> {
    return this.http.get(`${this.hostURL}/globalgst`);
  }
  deleteGlobalGst(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/globalgst/${id}`);
  }
  getGlobalService(): Observable<any> {  //fetch global service
    return this.http.get<any>(`${this.hostURL}/globalservice`);
  }

  showGlobalServiceById(id: number): Observable<any> { //fetch global service by id
    return this.http.get<any>(`${this.hostURL}/globalservice/${id}`);
  }

  createGlobalService(data: any): Observable<any> {  //create global service by id
    return this.http.post(`${this.hostURL}/globalservice`, data);
  }

  updateGlobalService(id: number, data: any): Observable<any> {  //update global service 
    return this.http.post(`${this.hostURL}/globalservice/${id}`, data);
  }

  hsnsacSample(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/downloadhsnsacsample`, data);
  }
  importExcel(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/hsnsacImport`, formData);
  }

  itemSample(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/downloaditemsample`, data);
  }
  importItemExcel(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/itemImport`, formData);
  }
  serviceSample(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/downloadserviceSample`, data);
  }

  importServiceExcel(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/serviceimport`, formData);
  }
 
  updatepobypass(data: any): Observable<any> {   //update po by pass type
    return this.http.post(`${this.hostURL}/tenants/pobypass`, data);
  }

  pricePolicy(data: any): Observable<any> {   //update price policy
    return this.http.post(`${this.hostURL}/tenants/price_policy`, data);
  }

  // Menu Access APIs
  getAvailableMenusFlat(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/acl/get_available_menus_flat`);
  }

  getUserMenus(data: any): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/acl/get_user_menus`, data);
  }
  updatePiSiManual(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/tenants/pi_si_manual`, data);
  }
  allEmployeeMasterList(data: any = {}): Observable<any> {
    return this.http.get(`${this.hostURL}/all-employee-master-list`, {
      params: data
    });
  }
}

